import { array } from 'ember-data-model-fragments/attributes';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import { attr } from '@ember-data/model';
import { convertUrlToImageFile } from '@square/dashboard-utilities/utils/file';
import Enum from '@square/dashboard-utilities/utils/enum';
export const MerchantImagePurposes = new Enum('SPOS_CHECKOUT', 'BUYER_FACING_DISPLAY', 'BUYER_FACING_DISPLAY_ON_TERMINAL');
export default EmberDataBaseModel.extend({
  userToken: attr('string'),
  url: attr('string'),
  file: attr('file'),
  fileName: attr('string'),
  center: array('string'),
  height: attr('number'),
  width: attr('number'),
  contentDigest: attr('string'),
  imagePurpose: attr('string'),
  imageOrder: attr('number'),
  requestImagePurpose: attr('string'),
  toFile() {
    return convertUrlToImageFile(this.url);
  }
}).reopenClass({
  _modelNameForMigration: 'legacy/merchant-image'
});